<script setup>
import { computed } from 'vue'
import store from '@/user/store'

const loading = computed(() => store.getters['LoaderStore/loading'])
</script>

<template>
  <div
    class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[20000]"
    v-if="loading">
    <span
      class="ico_area w-60 h-60 rounded-full"
      style="box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.2)">
      <img
        src="@/user/assets/img/ico_loading.gif"
        alt="loading"
        rel="preload"
        class="w-full h-full object-contain" />
    </span>
  </div>
</template>
